module.exports = __webpack_public_path__ + "img/topindicator4.261fba5f.png";